import { createSlice } from '@reduxjs/toolkit';

/**
 * Slice para mantener estado referente a feedback global del sistema, como estados de carga (loading...)
 * o notificaciones generales.
 */

//
// ─── ACTION MATCHERS ────────────────────────────────────────────────────────────
//

/**
 * Matches para los fetch pendientes,finalizados y rechazados de tipo "global". Este nombre se incluye al principio
 * del nombre de la acción a despachar (ver acciones async, por ej.: en cvSlice)
 */

const isPendingAction = (action) =>
  action.type.startsWith('global') && action.type.endsWith('pending');

const isFinalizedAction = (action) =>
  action.type.startsWith('global') &&
  (action.type.endsWith('fulfilled') || action.type.endsWith('rejected'));

//
// ─── SLICE ──────────────────────────────────────────────────────────────────────
//

export const feedbackSlice = createSlice({
  name: 'feedback',
  initialState: {
    loading: {
      status: 0,
      msg: '',
    },
    notif: {
      variant: null,
      msg: '',
    },
  },
  reducers: {
    //despachar la acción init resulta en un loading bloqueante
    init: (state, action) => {
      return {
        ...state,
        loading: { status: true, msg: action.payload || 'Cargando...' },
      };
    },
    //Despachar la acción finalize elimina el loading bloqueante
    finalize: (state) => {
      return {
        ...state,
        loading: { status: false, msg: '' },
      };
    },
    setNotification: (state, action) => {
      return {
        ...state,
        notif: {
          variant: action.payload.variant,
          msg: action.payload.msg,
          timeout: action.payload.timeout,
        },
      };
    },
    endNotification: (state, action) => {
      return {
        ...state,
        notif: {
          variant: null,
          msg: '',
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder
      //Considera un loading para cada acción pendiente que respete el matcher (ver definición del matcher mas arriba)
      .addMatcher(isPendingAction, (state, action) => {
        return {
          ...state,
          loading: {
            status: state.loading.status + 1,
            msg: action.meta.arg?.msg || '',
          },
        };
      })
      //remueve el loading bloqueante para cualquier acción de fetch finalizada (ver definición de matcher más arriba)
      .addMatcher(isFinalizedAction, (state, action) => {
        return {
          ...state,
          loading: {
            status: state.loading.status <= 0 ? 0 : state.loading.status - 1,
            msg: '',
          },
        };
      });
  },
});

export const { init, finalize, setNotification, endNotification } = feedbackSlice.actions;
export const isLoadingSelector = (state) => state.feedback.loading.status;
export const loadingMsgSelector = (state) => state.feedback.loading.msg;
export const notificationSelector = (state) => state.feedback.notif;
export default feedbackSlice.reducer;
